import { render, staticRenderFns } from "./EmptyBox.vue?vue&type=template&id=3bb146bf&"
import script from "./EmptyBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmptyBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmptyBox.vue?vue&type=style&index=0&id=3bb146bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports